import { z } from 'zod';

export const HealthResponse = z.object({
  ok: z.boolean(),
  version: z.string(),
  db: z.boolean(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;

/** Error body for every non-2xx API response. */
export const ApiErrorBody = z.object({ error: z.string(), message: z.string() });

export const OkResponse = z.object({ ok: z.literal(true) });
